import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=2972f2fe&scoped=true"
import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=2972f2fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972f2fe",
  null
  
)

export default component.exports